import React, { useState } from 'react';

const DEMO_RESPONSE_TEMPLATE = {
  role: 'Academic / researcher',
  subtitle: 'Associate Professor of Marketing',
  description: 'Expertise in marketing strategy and nonprofit communications matches the subject matter of this request.',
  matchedOn: 'Sep 9, 2026',
  status: 'Awaiting their decision',
  isNew: true,
};

const ResponseCard = ({ response }) => (
  <div className="br-grey brd-10 p-15 m-b-10">
    <div className="flex justspacebetween aligncenter">
      <div className="flex aligncenter gap-10">
        <div className="circle-avatar-sm bg-grey-1 flex aligncenter justifycenter">
          <i className="fas fa-user text-lite-gray font-14"></i>
        </div>
        <div>
          <div className="fw700 font-13 black">{response.role}</div>
          <div className="font-11 text-lite-gray">{response.subtitle}</div>
        </div>
      </div>
      {response.isNew && (
        <span className="badge badge-xxs font-11 fw500 w-unset bg-blue-white text-blue">
          New — not yet connected
        </span>
      )}
    </div>
    <div className="font-12 black-light-1 m-t-10">{response.description}</div>
    <div className="flex justspacebetween aligncenter m-t-15">
      <span className="font-11 text-lite-gray">Matched {response.matchedOn}</span>
      <span className="font-11 text-lite-gray">{response.status}</span>
    </div>
  </div>
);

const CfpResponsesModal = ({ submission }) => {
  const [search, setSearch] = useState('');
  const [responses, setResponses] = useState([]);

  const filtered = responses.filter((r) =>
    `${r.role} ${r.subtitle} ${r.description}`.toLowerCase().includes(search.toLowerCase())
  );

  const simulateMatch = () => {
    setResponses((prev) => [...prev, { ...DEMO_RESPONSE_TEMPLATE, id: `demo-${Date.now()}` }]);
  };

  return (
    <div className="bg-white brd-10 shadow-small p-20">
      <div className="fw700 font-16 color-black m-b-15">Responses — {submission?.title}</div>

      <div className="form-input-gray flex aligncenter gap-10 p-10 m-b-15">
        <i className="fas fa-search text-lite-gray font-12"></i>
        <input
          type="text"
          placeholder="Search responses by role, type, or content..."
          className="w-100p no-border"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {filtered.length === 0 ? (
        <div className="text-muted text-center p-20">No responses yet.</div>
      ) : (
        filtered.map((r) => <ResponseCard key={r.id} response={r} />)
      )}

      <div className="flex justspacebetween aligncenter m-t-15 br-top-grey p-t-15">
        <span className="font-11 text-lite-gray w-70p">
          Identities stay hidden until both sides agree to connect. You then see full contact details in the chat.
        </span>
        <button
          className="btn-primary bg-blue-dark text-white brd-5 font-12 fw500 p-8-15 flex aligncenter gap-5 no-border"
          onClick={simulateMatch}>
          <i className="fas fa-wand-magic-sparkles font-11"></i> Simulate a match (demo)
        </button>
      </div>
    </div>
  );
};

export default CfpResponsesModal;